module.exports = __webpack_public_path__ + "static/img/Ir.f4876b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/Ir.png
// module id = g88+
// module chunks = 1